import styled from "@emotion/styled";
import {SKELETON_LOADER} from "../const";

const {SKELETON_LOADER_BG} = SKELETON_LOADER;

export const RowContainer = styled('section')`
  display: flex;
  flex-flow: row wrap;
`;

export const ColumnContainer = styled('section')`
  display: flex;
  flex-flow: column nowrap;
`;

export const Divider = styled('hr')`
  background: #f3f6f8;
  height: 3px;
  border: 0;
`;

export const ErrorContainer = styled.ul`
  list-style: none;
`

export const InputContainer = styled.div`
  position: relative;
`

export const SkeletonLoader = styled('div')`
  background: ${SKELETON_LOADER_BG};
  display: flex;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  
  z-index: 1;
  border-radius: 10px;
  overflow: hidden;
`;

export const EllipsisContainer = styled('section')`
  height: 100%;
  text-overflow: ellipsis;
  overflow: hidden;

  // addition lines for two- or multiline ellipsis
  display: -webkit-box !important;
  -webkit-line-clamp: ${({lines = 1}: {lines: string|number}) => lines};
  -webkit-box-orient: vertical;
  white-space: normal;
  
  // normalize whitespace 
  p:last-child {
    margin-bottom: 0;
  }
`;

export const ArticleContainer = styled('article')`
  display: flex;
  flex-flow: ${({direction = 'row'}: {direction: string}) => direction} nowrap;
  width: 100%;
  flex: 1;
  position: relative;
`;

export const ContentContainer = styled('section')`
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  justify-content: flex-start;
`

export const HeaderContainer = styled('header')`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
`

export const FooterContainer = styled('footer')`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
`
